import IgoContainer from './components/IgoContainer'
import PublicSellSection from './components/PublicSellSection'

const IgoIfo = () => <IgoContainer igoSection={<PublicSellSection />} />

export default IgoIfo
